
require.context('../images', true)

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails";

Rails.start()

// app
import '../app/styles/index';

import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;

import 'bootstrap';
import 'bootstrap-notify/bootstrap-notify.min';
import 'daterangepicker';
import 'signature_pad';
import 'image-compare-viewer';


import '../app/components/notify';
import RemoteModal from '../app/components/remote-modal';
import '../app/components/modal-confirmation';
import MainMenu from '../app/components/main-menu';
import { trackHeightChanges } from '../app/components/track-height-changes';

// stimulus
import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const application = Application.start()
const context = require.context("controllers", true, /(datepicker|list_details|checkbox_group_required_validation|stripe.*|paypal.*|braintree.*|credit_card.*|signature_pad.*|before_after_gallery_item_viewer.*|fit_image.*|slide_menu.*|tel_input|display_switch|set_value|attachments|nested_fields)_controller\.js$/)
application.load(definitionsFromContext(context))
application.debug = false
window.Stimulus = application
window.RemoteModal = RemoteModal

jQuery(function(){
  RemoteModal.init()

  $(document).on('click', '.table-clickable tbody tr, .clickable-item', function (e) {
    if(!$(e.target).hasClass('dropdown-item') &&
       !$(e.target).hasClass('custom-control-label') &&
       !$(e.target).hasClass('selectable') &&
       !$(e.target).hasClass('remote-modal') &&
       !$(e.target).hasClass('not-clickable') &&
       !(e.target.tagName == 'A') ) {
      if($(this).data('target')) {
        RemoteModal.show($(this).data('target'), $(this).data('url'), { nested: $(this).data('nested'), fullscreen: $(this).data('fullscreen') });
      }else {
        Turbo.visit($(this).data('url'));
      }
    }
  });
});

jQuery(document).on('turbo:load', function() {
  new MainMenu();

  // track height for iframe work request
  if (document.getElementById('embedded-content-wrapper')) {
    window.trackHeightChanges = trackHeightChanges;
  }
})